"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailingAddress = exports.BillingAddress = exports.ShippingAddress = exports.AddressOptional = exports.Address = exports.CountryCodeEnum = exports.CountryEnum = void 0;
const data_ui_1 = require("../data-ui");
const typeorm_1 = require("typeorm");
const class_validator_1 = require("class-validator");
const user_role_enum_1 = require("./user-role-enum");
var CountryEnum;
(function (CountryEnum) {
    CountryEnum["GERMANY"] = "Germany";
    CountryEnum["FRANCE"] = "France";
    CountryEnum["BELGIUM"] = "Belgium";
    CountryEnum["AUSTRIA"] = "Austria";
    CountryEnum["USA"] = "USA";
    CountryEnum["SWITZERLAND"] = "Switzerland";
    CountryEnum["SWEDEN"] = "Sweden";
    CountryEnum["SLOVENIA"] = "Slovenia";
    CountryEnum["NETHERLANDS"] = "Netherlands";
    CountryEnum["ITALY"] = "Italy";
    CountryEnum["LUXEMBOURG"] = "Luxembourg";
    CountryEnum["TURKEY"] = "Turkey";
    CountryEnum["DENMARK"] = "Denmark";
    CountryEnum["UNITED_KINGDOM"] = "United Kingdom";
    CountryEnum["POLAND"] = "Poland";
    CountryEnum["CZECH_REPUBLIC"] = "Czech Republic";
})(CountryEnum = exports.CountryEnum || (exports.CountryEnum = {}));
var CountryCodeEnum;
(function (CountryCodeEnum) {
    CountryCodeEnum["GERMANY"] = "DE";
    CountryCodeEnum["FRANCE"] = "FR";
    CountryCodeEnum["BELGIUM"] = "BE";
    CountryCodeEnum["AUSTRIA"] = "AT";
    CountryCodeEnum["USA"] = "US";
    CountryCodeEnum["SWITZERLAND"] = "CH";
    CountryCodeEnum["SWEDEN"] = "SE";
    CountryCodeEnum["SLOVENIA"] = "SI";
    CountryCodeEnum["NETHERLANDS"] = "NL";
    CountryCodeEnum["ITALY"] = "IT";
    CountryCodeEnum["LUXEMBOURG"] = "LU";
    CountryCodeEnum["TURKEY"] = "TR";
    CountryCodeEnum["DENMARK"] = "DK";
    CountryCodeEnum["UNITED_KINGDOM"] = "GB";
    CountryCodeEnum["POLAND"] = "PL";
    CountryCodeEnum["CZECH_REPUBLIC"] = "CZ";
})(CountryCodeEnum = exports.CountryCodeEnum || (exports.CountryCodeEnum = {}));
class Address {
}
__decorate([
    (0, typeorm_1.Column)({
        name: 'street',
    }),
    __metadata("design:type", String)
], Address.prototype, "street", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'postalcode',
    }),
    __metadata("design:type", String)
], Address.prototype, "postalCode", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'city',
    }),
    __metadata("design:type", String)
], Address.prototype, "city", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'state',
        nullable: true,
    }),
    __metadata("design:type", String)
], Address.prototype, "state", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'statecode',
        nullable: true,
    }),
    __metadata("design:type", String)
], Address.prototype, "stateCode", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('countries'),
    (0, typeorm_1.Column)({
        name: 'country',
    }),
    __metadata("design:type", String)
], Address.prototype, "country", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('country_codes'),
    (0, typeorm_1.Column)({
        name: 'countrycode',
    }),
    __metadata("design:type", String)
], Address.prototype, "countryCode", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'latitude',
        nullable: true,
    }),
    __metadata("design:type", Number)
], Address.prototype, "latitude", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'longitude',
        nullable: true,
    }),
    __metadata("design:type", Number)
], Address.prototype, "longitude", void 0);
exports.Address = Address;
class AddressOptional {
}
__decorate([
    (0, typeorm_1.Column)({
        name: 'street',
        nullable: true,
    }),
    __metadata("design:type", String)
], AddressOptional.prototype, "street", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'additionalinfo',
        type: 'character varying',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], AddressOptional.prototype, "additionalInfo", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'postalcode',
        nullable: true,
    }),
    __metadata("design:type", String)
], AddressOptional.prototype, "postalCode", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'city',
        nullable: true,
    }),
    __metadata("design:type", String)
], AddressOptional.prototype, "city", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'state',
        nullable: true,
    }),
    __metadata("design:type", String)
], AddressOptional.prototype, "state", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'statecode',
        nullable: true,
    }),
    __metadata("design:type", String)
], AddressOptional.prototype, "stateCode", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('countries'),
    (0, typeorm_1.Column)({
        name: 'country',
        nullable: true,
    }),
    __metadata("design:type", String)
], AddressOptional.prototype, "country", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('country_codes'),
    (0, typeorm_1.Column)({
        name: 'countrycode',
        nullable: true,
    }),
    __metadata("design:type", String)
], AddressOptional.prototype, "countryCode", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'latitude',
        nullable: true,
    }),
    __metadata("design:type", Number)
], AddressOptional.prototype, "latitude", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'longitude',
        nullable: true,
    }),
    __metadata("design:type", Number)
], AddressOptional.prototype, "longitude", void 0);
exports.AddressOptional = AddressOptional;
const isCustomer = (obj) => {
    return (obj === null || obj === void 0 ? void 0 : obj.role) === user_role_enum_1.UserRoleEnum.CUSTOMER;
};
class ShippingAddress {
}
__decorate([
    data_ui_1.DataUi.Override({
        label: (obj) => isCustomer(obj) ? 'Shipping address street' : 'Company address street',
    }),
    (0, class_validator_1.IsNotEmpty)({
        message: 'Address street can not be empty',
    }),
    (0, typeorm_1.Column)({
        name: 'shippingstreet',
        type: 'character varying',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], ShippingAddress.prototype, "street", void 0);
__decorate([
    data_ui_1.DataUi.Override({
        label: (obj) => isCustomer(obj) ? 'Shipping additional info' : 'Company additional info',
    }),
    (0, typeorm_1.Column)({
        name: 'shippingadditionalinfo',
        type: 'character varying',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], ShippingAddress.prototype, "additionalInfo", void 0);
__decorate([
    data_ui_1.DataUi.Override({
        label: (obj) => isCustomer(obj) ? 'Shipping postal code' : 'Company address postal code',
    }),
    (0, class_validator_1.IsNotEmpty)({
        message: 'Address postal code can not be empty',
    }),
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 20,
        name: 'shippingpostalcode',
        nullable: true,
    }),
    __metadata("design:type", String)
], ShippingAddress.prototype, "postalCode", void 0);
__decorate([
    data_ui_1.DataUi.Override({
        label: (obj) => isCustomer(obj) ? 'Shipping address city ' : 'Company address city',
    }),
    (0, class_validator_1.IsNotEmpty)({
        message: 'Address city can not be empty',
    }),
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 40,
        name: 'shippingcity',
        nullable: true,
    }),
    __metadata("design:type", String)
], ShippingAddress.prototype, "city", void 0);
__decorate([
    data_ui_1.DataUi.Override({
        label: (obj) => (isCustomer(obj) ? 'Shipping state ' : 'Company state'),
    }),
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 80,
        name: 'shippingstate',
        nullable: true,
    }),
    __metadata("design:type", String)
], ShippingAddress.prototype, "state", void 0);
__decorate([
    data_ui_1.DataUi.Override({
        label: (obj) => isCustomer(obj) ? 'Shipping state code' : 'Company state code',
    }),
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 10,
        name: 'shippingstatecode',
        nullable: true,
    }),
    __metadata("design:type", String)
], ShippingAddress.prototype, "stateCode", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('countries'),
    data_ui_1.DataUi.Override({
        label: (obj) => (isCustomer(obj) ? 'Shipping country' : 'Company country'),
    }),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 80,
        name: 'shippingcountry',
        nullable: true,
    }),
    __metadata("design:type", String)
], ShippingAddress.prototype, "country", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('country_codes'),
    data_ui_1.DataUi.Override({
        label: (obj) => isCustomer(obj) ? 'Shipping country code' : 'Company country code',
    }),
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 10,
        name: 'shippingcountrycode',
        nullable: true,
    }),
    __metadata("design:type", String)
], ShippingAddress.prototype, "countryCode", void 0);
__decorate([
    data_ui_1.DataUi.Override({
        label: (obj) => isCustomer(obj) ? 'Shipping latitude' : 'Company latitude',
    }),
    (0, typeorm_1.Column)({
        type: 'double precision',
        name: 'shippinglatitude',
        nullable: true,
    }),
    __metadata("design:type", Number)
], ShippingAddress.prototype, "latitude", void 0);
__decorate([
    data_ui_1.DataUi.Override({
        label: (obj) => isCustomer(obj) ? 'Shipping longitude' : 'Company longitude',
    }),
    (0, typeorm_1.Column)({
        type: 'double precision',
        name: 'shippinglongitude',
        nullable: true,
    }),
    __metadata("design:type", Number)
], ShippingAddress.prototype, "longitude", void 0);
exports.ShippingAddress = ShippingAddress;
class BillingAddress {
}
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 255,
        name: 'billingstreet',
        nullable: true,
    }),
    __metadata("design:type", String)
], BillingAddress.prototype, "street", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'billingadditionalinfo',
        type: 'character varying',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], BillingAddress.prototype, "additionalInfo", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 20,
        name: 'billingpostalcode',
        nullable: true,
    }),
    __metadata("design:type", String)
], BillingAddress.prototype, "postalCode", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 40,
        name: 'billingcity',
        nullable: true,
    }),
    __metadata("design:type", String)
], BillingAddress.prototype, "city", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 80,
        name: 'billingstate',
        nullable: true,
    }),
    __metadata("design:type", String)
], BillingAddress.prototype, "state", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 10,
        name: 'billingstatecode',
        nullable: true,
    }),
    __metadata("design:type", String)
], BillingAddress.prototype, "stateCode", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('countries'),
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 80,
        nullable: true,
        name: 'billingcountry',
    }),
    __metadata("design:type", String)
], BillingAddress.prototype, "country", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('country_codes'),
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 10,
        nullable: true,
        name: 'billingcountrycode',
    }),
    __metadata("design:type", String)
], BillingAddress.prototype, "countryCode", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'double precision',
        name: 'billinglatitude',
        nullable: true,
    }),
    __metadata("design:type", Number)
], BillingAddress.prototype, "latitude", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'double precision',
        name: 'billinglongitude',
        nullable: true,
    }),
    __metadata("design:type", Number)
], BillingAddress.prototype, "longitude", void 0);
exports.BillingAddress = BillingAddress;
class MailingAddress {
}
__decorate([
    (0, typeorm_1.Column)({
        name: 'mailingstreet',
        type: 'character varying',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], MailingAddress.prototype, "street", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 20,
        name: 'mailingpostalcode',
        nullable: true,
    }),
    __metadata("design:type", String)
], MailingAddress.prototype, "postalCode", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 40,
        name: 'mailingcity',
        nullable: true,
    }),
    __metadata("design:type", String)
], MailingAddress.prototype, "city", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 80,
        name: 'mailingstate',
        nullable: true,
    }),
    __metadata("design:type", String)
], MailingAddress.prototype, "state", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 10,
        name: 'mailingstatecode',
        nullable: true,
    }),
    __metadata("design:type", String)
], MailingAddress.prototype, "stateCode", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('countries'),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 80,
        name: 'mailingcountry',
        nullable: true,
    }),
    __metadata("design:type", String)
], MailingAddress.prototype, "country", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('country_codes'),
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 10,
        name: 'mailingcountrycode',
        nullable: true,
    }),
    __metadata("design:type", String)
], MailingAddress.prototype, "countryCode", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'double precision',
        name: 'mailinglatitude',
        nullable: true,
    }),
    __metadata("design:type", Number)
], MailingAddress.prototype, "latitude", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'double precision',
        name: 'mailinglongitude',
        nullable: true,
    }),
    __metadata("design:type", Number)
], MailingAddress.prototype, "longitude", void 0);
exports.MailingAddress = MailingAddress;
//# sourceMappingURL=address.js.map